import { render, staticRenderFns } from "./BankCardInfo.vue?vue&type=template&id=200f2482&scoped=true"
import script from "./BankCardInfo.vue?vue&type=script&lang=js"
export * from "./BankCardInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f2482",
  null
  
)

export default component.exports